export default {
  bulkUpload: 'BULK_UPLOAD',
  bulkUploadSuccess: 'BULK_UPLOAD_SUCCESS',
  bulkUploadFailed: 'BULK_UPLOAD_FAILED',
  toggleModalState: 'TOGGLE_MODAL_STATE',
  resetToInitialState: 'RESET_TO_INITIAL_STATE',
  getLastUploadDetails: 'GET_LAST_UPLOAD_DETAILS',
  getLastUploadDetailsSuccess: 'GET_LAST_UPLOAD_DETAILS_SUCCESS',
  getLastUploadDetailsFailed: 'GET_LAST_UPLOAD_DETAILS_FAILED',
};
